import ColorsStyles from '@Styles/colors.scss';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    AccordionSummaryProps,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import _isEmpty from 'lodash/isEmpty';
import _isNil from 'lodash/isNil';
import PropTypes from 'prop-types';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { WorkbenchType } from '@Data/workbenches/Interfaces';
import { selectedWorkbenchState } from '@Data/workbenches/Reducer';
import Styles from './EntityDrawer.scss';
import EntityDrawerAttributeRow from './EntityDrawerAttributeRow';
import { renderIkeOfficeData, renderPoleBasics } from './EntityDrawerUtils';
import NestedAccordion from './NestedAccordion/NestedAccordion';

// import testData from '../../../__test_data__/IkeOfficeData.json';

const AttributesAccordionSummary = styled((props: AccordionSummaryProps) => (
    <AccordionSummary
        expandIcon={
            <ExpandMoreIcon sx={{ fontSize: '0.5rem', color: '#1A1E2C' }} />
        }
        {...props}
    />
))(({ theme }) => ({
    fontFamily: 'Barlow Condensed',
    backgroundColor: '#C9CDD2',
    minHeight: '19px',
    maxHeight: '19px',
    alignItems: 'center',
    fontSize: '12px',
    lineHeight: '19px',
    letterSpacing: '0.02em',
    margin: 0,
    paddingLeft: '8px',
    color: ColorsStyles.ikeGradient1,
    flexDirection: 'row-reverse',
    gap: '8px',
    userSelect: 'auto',
    '&:hover': {
        backgroundColor: '#E0E3E7',
        borderLeft: '2px solid #1FA163',
    },
    root: {
        '&.Mui-expanded': {
            margin: '0 !important',
            minHeight: '19px !important',
            maxHeight: '19px',
        },
    },
}));

const EntityDrawerAttributesSection = (props) => {
    const { title, data, selectedEntity, startOpen, onToggle } = props;

    const workbenchState = useSelector(selectedWorkbenchState);

    let ikeOfficeData = [];
    if (!_isNil(selectedEntity?.generic_data[0]?.fields)) {
        if (workbenchState === WorkbenchType.QC) {
            ikeOfficeData = renderPoleBasics(selectedEntity);
        } else {
            ikeOfficeData = renderIkeOfficeData(selectedEntity);
        }
    }

    return (
        <Accordion
            id="entity-data-accordion"
            defaultExpanded={true}
            square={true}
            disableGutters
            sx={{
                '&.Mui-expanded': {
                    minHeight: '19px !important',
                },
                '::before': {
                    display: 'none',
                },
                overflowX: 'hidden',
                paddingBottom: '5px',
            }}
        >
            <AttributesAccordionSummary>
                <div className={Styles.attributeAccordionTitleContainer}>
                    <span id="entity-data-accordion-title">{title}</span>
                </div>
            </AttributesAccordionSummary>
            <AccordionDetails id="entity-data-accordion-details">
                {!_isNil(selectedEntity?.generic_data[0]?.fields)
                    ? ikeOfficeData
                    : data}
            </AccordionDetails>
        </Accordion>
    );
};

EntityDrawerAttributesSection.propTypes = {
    data: PropTypes.any,
    selectedEntity: PropTypes.any,
    title: PropTypes.string,
    startOpen: PropTypes.bool,
    onToggle: PropTypes.func,
};

EntityDrawerAttributesSection.defaultProps = {
    startOpen: true,
};
export default EntityDrawerAttributesSection;
